import { Role } from "../../../helpers/role";

export const ServiceProviderMenu = [
  {
    title: "Home",
    icon: "mdi-view-dashboard",
    to: "",
    code: "home",
    role: [Role.ServiceProvider],
  },

  {
    title: "Distributor",
    icon: "mdi-domain",
    role: [Role.ServiceProvider],
    code: "main-distributor",
    submenu: [
      {
        title: "List",
        icon: "",
        to: "distributor-list",
        code: "distributor-list",
        role: [Role.ServiceProvider],
      },
      {
        title: "Pending Approval",
        icon: "",
        to: "distributor-pending-approval",
        code: "distributor-pending-approval",
        role: [Role.ServiceProvider],
        data: ["sp.approver", "sp.approver2"]
      },

      {
        title: "Pending Verification",
        icon: "",
        to: "distributor-pending-approval",
        code: "distributor-pending-approval",
        role: [Role.ServiceProvider],
        data: ["sp.verifier"]
      },

      {
        title: "Denied",
        icon: "",
        to: "distributor-denied",
        code: "distributor-denied",
        role: [Role.ServiceProvider],
      },
    ],
  },

  {
    title: "Top-up Request",
    icon: "mdi-email-receive-outline",
    code: "main-topup-request",
    role: [Role.ServiceProvider],
    submenu: [
      {
        // title: "Pending Approval",
        title: "Pending Approval",
        icon: "",
        to: "topup-request-pending-approval",
        code: "topup-request-pending-approval",
        role: [Role.ServiceProvider],
        data: ["sp.approver", "sp.approver2"]
      },

      {
        title: "Pending Verification",
        icon: "",
        to: "topup-request-pending-approval",
        code: "topup-request-pending-approval",
        role: [Role.ServiceProvider],
        data: ["sp.verifier"]
      },
      {
        title: "History",
        icon: "",
        to: "topup-request-history",
        code: "topup-request-history",
        role: [Role.ServiceProvider],
      },
    ],
  },

  {
    title: "Revenue Report",
    icon: "mdi-currency-usd",
    to: "revenue-report",
    code: "revenue-report",
    role: [Role.ServiceProvider],
  },
  {
    title: "Accounts",
    icon: "mdi-account-supervisor",
    code: "main-service-accounts",
    role: [Role.ServiceProvider],
    submenu: [
      {
        title: "List",
        icon: "",
        to: "accounts",
        code: "accounts",
        role: [Role.ServiceProvider],
      },
      {
        title: "Create",
        icon: "",
        to: "create-account",
        code: "create-account",
        role: [Role.ServiceProvider],
      },
    ],
  },
];
